/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowScavengerHuntTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowScavengerHunt,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let the Hunt Begin!",
    "Adventure Awaits!",
    "Scavenger Hunt Excitement!",
  ],
  title: "Scavenger Hunt",
  description: "Organize a thrilling scavenger hunt.",
  longDescription:
    "Plan an exciting scavenger hunt with friends! Choose a date, set the locations, and decide on the items to find!",
  emoji: "🔍",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Scavenger Hunt",
          emoji: "🔍",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the scavenger hunt?",
          emoji: "📅",
          completeAction: {
            question: "Decide on locations for the hunt?",
            description: "Where should we have our scavenger hunt?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What locations should we include?",
                emoji: "📍",
                completeAction: {
                  question: "Decide on items to find?",
                  description:
                    "What items should we include in the scavenger hunt?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What items should we search for?",
                      emoji: "📝",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Ready, Set, Hunt!",
    outroDescription: "Your scavenger hunt plans are set! Enjoy the adventure!",
  },
};
